<template>
  <!-- Modal background -->
  <div class="modal" v-resize @resize="onResize($event)">

    <Loader v-show="loading" />

    <div v-show="!loading" class="modal-card">
      <div class="action-buttons image-view__header">
        <button class="action-button" @click="onDelete($event, image)">Delete</button>
        <button class="action-button" @click="$emit('closeModal')">Close</button>
      </div>

      <div class="image-view__container">
        <img
          :src="signedUrl"
          :alt="image.name"
          :width="imageWidth"
          @load="onLoad($event)"
        />
      </div>
    </div>

  </div>
</template>


<script>
import Loader from './Loader';

export default {
  name: 'image-modal',
  props: {
    image: { type: Object },
    deleteFile: { type: Function }
  },
  components: {
    Loader
  },
  data() {
    return {
      loading: true,
      signedUrl: null,
      imgDimensions: null,
      imageWidth: 0
    }
  },
  methods: {
    onResize(e) {
      if(!this.imgDimensions) return;

      // It is subtracted for 100 because we want the image to have margins when adjusted.
      const modalDimensions = {
        width: e.detail.width - 100,
        height: e.detail.height - 100
      };

      this.calculateImgWidth(this.imgDimensions, modalDimensions);
    },
    onLoad(e) {
      const imgDimensions = {
        width: e.target.naturalWidth,
        height: e.target.naturalHeight,
      };
      
      // It is subtracted for 100 because we want the image to have margins when adjusted.
      const containerDimensions = {
        width: window.innerWidth - 100,
        height: window.innerHeight - 100
      };

      // Calculate image width.
      this.calculateImgWidth(imgDimensions, containerDimensions);
      
      // Save image HTML element to recalculate its width when viewport changes.
      this.imgDimensions = imgDimensions;
      this.loading = false;
    },
    calculateImgWidth(image, modal) {
      // Calculate image size ratio (useful to prevent displaying stretched images).
      const imgSizeRatio = image.height / image.width;

      // Original image width.
      let imageWidth = image.width;

      // Fix image width and height if necessary.
      if(image.width > modal.width && image.height > modal.height) {
        imageWidth = modal.height / imgSizeRatio;

        // If the image has a ratio with its WIDTH greater than its HEIGHT, then simply match its WIDTH with the WIDTH of the modal.
        if(imageWidth > modal.width)
          imageWidth = modal.width;
      }

      // Fix image height if necessary.
      else if(image.height > modal.height) {
        imageWidth = modal.height / imgSizeRatio;
      }
      
      // Fix image width if necessary.
      else if(image.width > modal.width) {
        imageWidth = modal.width;
      };

      this.imageWidth = imageWidth;
    },
    onDelete(e, image) {
      this.deleteFile(e, image);
      this.$emit('closeModal');
    }
  },
  async beforeMount() {
    // Get image signedUrl from API.
    const data = await this.$Amplify.API.get(
      'API',
      `/files/${this.$route.params.recordTypeSalesforceId}/${this.image.id}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );

    // Set image url.
    this.signedUrl = data.signedUrl;

  }
}
</script>

<style lang="scss">
  .image-view__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
  }

  .image-view__container {
    text-align: center;
  }

</style>
